import React, { PureComponent } from 'react';
import { Flex } from 'app/components/common/Flex';
import './MapConvectionLabel.css';
import { CloseCircleOutlined } from '@ant-design/icons';
import ConditionalRender from 'app/common/components/ConditionalRender';
import { ConvectionSource } from 'app/model/SOL49';

export class ConvectionLabelTitle extends PureComponent<{ onClose: () => void }> {
    render() {
        return (
            <Flex>
                <Flex style={{ fontWeight: 'bold', justifyContent: 'center' }}>LEGEND</Flex>
                <Flex grow={false} style={{ alignSelf: 'flex-end' }}>
                    <CloseCircleOutlined style={{ fontSize: '1.5em' }} onClick={this.props.onClose} />
                </Flex>
            </Flex>
        );
    }
}

export class ConvectionLabelContent extends PureComponent<{ source: ConvectionSource }> {
    render() {
        return (
            <table className="center fixDimensions border">
                <tbody>
                    <ConditionalRender condition={this.props.source !== ConvectionSource.DWD}>
                        <tr>
                            <td style={{ width: '6em', textAlign: 'right' }}>Very likely</td>
                            <td className="orange">ISOL</td>
                            <td className="red">CLST</td>
                            <td className="purple">WSPR</td>
                        </tr>
                        <tr>
                            <td style={{ textAlign: 'right' }}>Likely</td>
                            <td className="yellow">ISOL</td>
                            <td className="orange">CLST</td>
                            <td className="red">WSPR</td>
                        </tr>
                        <tr>
                            <td style={{ textAlign: 'right' }}>Less likely</td>
                            <td />
                            <td className="yellow">CLST</td>
                            <td className="orange">WSPR</td>
                        </tr>
                    </ConditionalRender>
                    <ConditionalRender condition={this.props.source === ConvectionSource.DWD}>
                        <tr>
                            <td style={{ width: '6em', textAlign: 'right' }}>Very likely</td>
                            <td className="isol_very_likely">ISOL</td>
                            <td className="clst_very_likely">CLST</td>
                            <td className="wspr_very_likely">WSPR</td>
                        </tr>
                        <tr>
                            <td style={{ textAlign: 'right' }}>Likely</td>
                            <td className="isol_likely">ISOL</td>
                            <td className="clst_likely">CLST</td>
                            <td className="wspr_likely">WSPR</td>
                        </tr>
                        <tr>
                            <td style={{ textAlign: 'right' }}>Less likely</td>
                            <td />
                            <td className="clst_less_likely">CLST</td>
                            <td className="wspr_less_likely">WSPR</td>
                        </tr>
                    </ConditionalRender>
                    <tr>
                        <td style={{ height: '4em', textAlign: 'right' }}>
                            <p style={{ marginBottom: 0 }}>Occurrence</p>
                            <p>of CB clouds</p>
                        </td>
                        <td>Isolated</td>
                        <td>Clustered</td>
                        <td>Widespread</td>
                    </tr>
                </tbody>
            </table>
        );
    }
}
